import { render, staticRenderFns } from "./addrequisition.vue?vue&type=template&id=9bb8325c&scoped=true&"
import script from "./addrequisition.vue?vue&type=script&lang=js&"
export * from "./addrequisition.vue?vue&type=script&lang=js&"
import style0 from "./addrequisition.vue?vue&type=style&index=0&id=9bb8325c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb8325c",
  null
  
)

export default component.exports